export default __webpack_public_path__ + "static/media/Victoria.03b52623.mp3";